export default {
  QUESTION_TYPE_STEP: {
    CHOOSE_QUESTION_TYPE: 'CHOOSE_QUESTION_TYPE',
    START_QUESTION_TYPE: 'START_QUESTION_TYPE',
    CHANGE_MODEL: 'CHANGE_MODEL',
    MAP: 'MAP'
  },
  QUESTION_TYPES: {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    MULTIPLE_CHOICE_PICK_LIST: 'MULTIPLE_CHOICE_PICK_LIST',
    MULTIPLE_CHOICE_DATE_PICK: 'MULTIPLE_CHOICE_DATE_PICK',
    ONE_FIVE_SCALE_MULTIPLE_CHOICE: 'ONE_FIVE_SCALE_MULTIPLE_CHOICE',
    SATISFACTION: 'SATISFACTION',
    SATISFACTION_LIKERT: 'SATISFACTION_LIKERT',
    RATING_SATISFACTION: 'RATING_SATISFACTION',
    SATISFACTION_RATING_THING: 'SATISFACTION_RATING_THING',
    PERCENTAGE: 'PERCENTAGE',
    PERCENTAGE_SCALE: 'PERCENTAGE_SCALE',
    MULTIPLE_SELECT: 'MULTIPLE_SELECT',
    MULTIPLE_SELECT_MORE_THAN_ONE_ANSWER: 'MULTIPLE_SELECT_MORE_THAN_ONE_ANSWER',
    STACK_RANKING: 'STACK_RANKING',
    STACK_RANKING_HIGH_TOP: 'STACK_RANKING_HIGH_TOP',
    STACK_RANKING_LOW_BOTTOM: 'STACK_RANKING_LOW_BOTTOM',
    OPEN_TEXT: 'OPEN_TEXT',
    OPEN_TEXT_SHORT_ANSWER: 'OPEN_TEXT_SHORT_ANSWER',
    OPEN_TEXT_LONG_ANSWER: 'OPEN_TEXT_LONG_ANSWER',
    OPEN_TEXT_NUMERIC_ANSWER: 'OPEN_TEXT_NUMERIC_ANSWER',
    OPEN_TEXT_CONSENT_DELIVERY: 'OPEN_TEXT_CONSENT_DELIVERY',
    SLIDER: 'SLIDER',
    CALCULATION_VARIABLE: 'CALCULATION_VARIABLE',
    PAGE_BREAK: 'PAGE_BREAK'
  },
  SPECIAL_TYPE: {
    FLOURING_INDEX: 'FLOURING_INDEX',
    HUMAN_PERFORMANCE_ASSESSMENT: 'HUMAN_PERFORMANCE_ASSESSMENT',
    TOBACCO_ATTESTATION: 'TOBACCO_ATTESTATION'
  }
};
